import { render, staticRenderFns } from "./ticketShareRecord.vue?vue&type=template&id=3c5a546e&"
import script from "./ticketShareRecord.vue?vue&type=script&lang=js&"
export * from "./ticketShareRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c5a546e')) {
      api.createRecord('3c5a546e', component.options)
    } else {
      api.reload('3c5a546e', component.options)
    }
    module.hot.accept("./ticketShareRecord.vue?vue&type=template&id=3c5a546e&", function () {
      api.rerender('3c5a546e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/oilActivityManage/ticketShare/ticketShareRecord.vue"
export default component.exports